'use client';

import { createContext } from 'react';
var documentContext = /*#__PURE__*/createContext(null);
export default documentContext;